import TooltipImpl from './tooltip.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;
/**
 * Tooltip component. Typically, a short messages related to specific UI element that provide additional explanations
 * and guide users towards taking specific actions. Can contain an icon next to a text.
 *
 * @function Tooltip
 * @memberof Mojito.Presentation.Components
 */

/**
 * Tooltip prop types.
 *
 * @property {Function} [onClick = () => {}] - Callback triggered once tooltip clicked.
 * @property {Function} [onClose = () => {}] - Callback for closing tooltip.
 * @property {Function} [onLinkClick = () => {}] - Callback for popup content link click.
 * @property {string} [linkText] - Popup content link text.
 * @property {boolean} [showTooltipButton] - Indicates whether tooltip button should be rendered.
 * @property {Function} [onOutsideClick = () => {}] - Callback for outside click.
 * @property {string} [text] - Content text.
 * @property {object | Function} [elementRef] - A ref to the rendered element.
 * @property {object | Function} [arrowRef] - A ref to the arrow rendered element.
 * @property {string} [class] - Class name assigned to the root element.
 * @memberof Mojito.Presentation.Components.Tooltip
 */
const propTypes = {
    onClick: PropTypes.func,
    onClose: PropTypes.func,
    onLinkClick: PropTypes.func,
    linkText: PropTypes.string,
    showTooltipButton: PropTypes.bool,
    onOutsideClick: PropTypes.func,
    text: PropTypes.string,
    elementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    arrowRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    class: PropTypes.string,
};

const defaultProps = {
    onClick: noop,
    onClose: noop,
    onOutsideClick: noop,
    onLinkClick: noop,
};

export default UIView('Tooltip', TooltipImpl, propTypes, defaultProps);
